// extracted by mini-css-extract-plugin
export default {"container":"dq-z","ratingLayout":"eq-z","ratingLabel":"fq-z","nonInteractiveRatingLabel":"gq-z"};